export default "__VITE_ASSET__CCx1lLwM__"